import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"filter\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.6 4.4c0-.22.18-.4.4-.4h14a.4.4 0 0 1 0 .8H3a.4.4 0 0 1-.4-.4ZM5.6 10.4c0-.22.18-.4.4-.4h8a.4.4 0 0 1 0 .8H6a.4.4 0 0 1-.4-.4ZM8 16.4c0-.22.18-.4.4-.4h3a.4.4 0 0 1 0 .8h-3a.4.4 0 0 1-.4-.4Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol